var SENTRY_RELEASE;SENTRY_RELEASE={name: "superclinical-fe", version: "1.0.0"};